import "./cards.css";

export default function StatCard({ title, value, icon: Icon, accent = "purple", type = "main" }) {
  return (
    <div className={`statCard ${accent} ${type === 'sidebar' ? 'miniCard' : ''}`}>
      <div className="statTop">
        <div className="statIcon">
          {Icon ? <Icon size={type === 'sidebar' ? 18 : 22} /> : null}
        </div>
        {type === 'sidebar' && <div className="statValue">{value}</div>}
      </div>

      <div className="statBody">
        {type === 'main' && <div className="statValue">{value}</div>}
        <div className="statTitle">{title}</div>
      </div>
    </div>
  );
}